import type { FC, ReactNode } from 'react'

import { Reveal } from '@/components/generals/reveal'

import CountUp from '@/components/generals/count-up'
import PixelFlower from '@/components/pixel/pixel-flower'
import ScrollLitText from '@/components/landing/scroll-lit-text'

import { INTRO_TEXT, STATS } from '@/constants/content'

const HIGHLIGHTS = ['dinosaur', 'hearts', 'everything']

const IntroSection: FC = (): ReactNode => {
    return (
        <section id='about' aria-labelledby='about-title' className='relative overflow-x-clip py-24 md:py-36'>
            <h2 id='about-title' className='sr-only'>
                About dinolab
            </h2>

            <PixelFlower className='pointer-events-none absolute top-10 -left-12 w-36 animate-spin-slow md:top-16 md:left-[6%] md:w-48' />

            <div className='relative mx-auto max-w-5xl px-5 md:px-8'>
                <ScrollLitText
                    text={INTRO_TEXT}
                    highlights={HIGHLIGHTS}
                    className='text-center text-[1.05rem] leading-[1.5] font-bold uppercase md:text-[1.55rem] md:leading-[1.45]'
                />
            </div>

            <dl className='relative mx-auto mt-20 grid max-w-6xl gap-12 px-5 sm:grid-cols-3 md:mt-28 md:px-8'>
                {STATS.map((stat, index) => (
                    <Reveal key={stat.label} delay={index * 140} className='flex flex-col-reverse'>
                        <dt className='mt-3 max-w-[11rem] text-sm leading-tight font-semibold md:text-base'>
                            {stat.label}
                        </dt>

                        <dd className='flex items-end gap-1 font-heading text-6xl leading-none whitespace-nowrap md:text-7xl lg:text-8xl'>
                            <CountUp value={stat.value} />
                            <span className='text-bubblegum'>{stat.suffix}</span>
                        </dd>
                    </Reveal>
                ))}
            </dl>

            <PixelFlower className='pointer-events-none absolute -right-20 -bottom-28 w-64 animate-sway md:-right-12 md:w-96' />
        </section>
    )
}

export default IntroSection
